import { registerPlugin } from '@capacitor/core'

interface SystemBarsBackgroundPlugin {
  setBackgroundColor(options: { color: string }): Promise<void>
}

export const SystemBarsBackground = registerPlugin<SystemBarsBackgroundPlugin>('SystemBarsBackground')
